(function ($) {
  'use strict';

  var SCROLL_TIMING = 600;
  var ACTIVE_LINK_CLASS = 'is-active';
  var $htmlBody = $('html, body');
  var $container;
  var $window = $(window);
  var $headerHeight = $('#l--main-header').outerHeight();
  var $toggle = $('.jump-links-toggle');
  var $chapterMenu = $('.chapter-menu');
  var DEFAULT_LABEL = 'Expand Menu';
  var CLOSE_LABEL = 'Collapse Menu';

  var initMenu = function (context) {
    $container = $(this);
    var $menuContainer = $('.chapter-menu', $container);
    var $links = $menuContainer.find('a');
    var hashParams;

    // click on toggle
    $toggle.on('click', function (e) {
      toggleLandingpageMenu(this);
    });

    $(window).on('resize', function () {
      if ($chapterMenu.hasClass('is-active')) {
        toggleLandingpageMenu($toggle);
      }
    });

    var toggleLandingpageMenu = function (el) {
      $chapterMenu.toggleClass('is-active');
      $(el).toggleClass('is-active');
      $(el).attr('aria-label', CLOSE_LABEL);

      if (!$chapterMenu.hasClass('is-active')) {
        $(el).attr('aria-label', DEFAULT_LABEL);
        $chapterMenu.removeClass('is-active');
      }
    };

    var selectChapter = function ($links) {
      if (window.location.hash) {
        hashParams = new URLSearchParams(window.location.hash.replace('#', ''));
        var $selectedLink = $links.toArray().reduce(function (acc, link) {
          var $link = $(link);
          var id = $link.attr('href');
          acc = acc || ((id === '#' + hashParams.get('chapter')) ? $link : false);
          return acc;
        }, false);
        if ($selectedLink) {
          $selectedLink.click();
        }
      }
    };

    if ($links.length === 0) {
      return;
    }

    $links.on('click', function (e) {
      e.preventDefault();
      $($links).removeClass(ACTIVE_LINK_CLASS);
      var target = $(this);
      target.addClass(ACTIVE_LINK_CLASS);
      hashParams = new URLSearchParams(window.location.hash.replace('#', ''));
      var targetHref = target.attr('href');
      var scrollPos = $(targetHref, $('.content-main')).offset().top;

      $htmlBody.stop().animate({
        scrollTop: scrollPos - $headerHeight - $chapterMenu.outerHeight()
      }, SCROLL_TIMING);

      hashParams.set('chapter', targetHref.replace('#', ''));
      window.location.hash = hashParams.toString();

      $chapterMenu.removeClass('is-active');
      $toggle.removeClass('is-active');
      $toggle.attr('aria-label', DEFAULT_LABEL);
    });

    selectChapter($links);
    calculateScroll();

    $(window).on('scroll.chapteredMenu', function () {
      calculateScroll();
    });
  };


  function calculateScroll() {
    $('.chapter-menu a.is-active', $container).removeClass('is-active');

    $('.chaptered-nav-anchor').each(function (i, el) {
      var $el = $(el);
      var $wrapper = $el.closest('.c--micro-site-jump-links');
      var elementTop = $el.offset().top;
      var viewportTop = $window.scrollTop();
      var viewportHeight = $window.height();
      var additionalOffset = 100;

      if ($wrapper.height() > viewportHeight) {
        additionalOffset = $wrapper.height() / 2;
      }
      else if ($wrapper.height() >= 300) {
        additionalOffset = 100;
      }

      if ($el.attr('id')) {
        if (elementTop + additionalOffset - viewportTop >= $headerHeight && elementTop - viewportTop <= viewportHeight) {
          var id = $el.attr('id');
          $('.chapter-menu a.is-active', $container).removeClass('is-active');
          $('.chapter-menu a[href="' + '#' + id + '"]', $container).addClass('is-active');
          return false;
        }
      }
    });
  }

  window.DP.behaviors.micrositeJumpMenu = {
    attach: function (context) {
      once('micrositeJumpMenu', '.cc--micro-site-jump-links', context)
        .forEach((e) => {
          initMenu.apply(e);
        });
      // $(context).find('.cc--micro-site-jump-links').once('micrositeJumpMenu').each(function () {
      //   initMenu.apply(this);
      // });
    }
  };

}(jQuery));
